export default "__VITE_ASSET__KRtFMlSO__"